import { ImagePreviewer } from "./image";
import { VideoPreviewer } from "./video";
import { PdfPreviewer } from "./pdf";

export const renderers = [ImagePreviewer, VideoPreviewer, PdfPreviewer];
